const LIST_PATH = "/revenue_opportunities";

/**
 * The record page a create action started from. It decides which relation
 * fields the form locks and whether the entity prefill applies.
 */
export const FORM_ORIGINS = {
  entity: "entity",
  contact: "contact",
  case: "case",
  campaign: "campaign",
  campaignTarget: "campaign_target",
};

/**
 * The origins whose entity supplies the new record's Campaign, Region, and
 * Country. On a Contact or Case page that is the parent or linked entity.
 */
export const ENTITY_ORIGINS = [
  FORM_ORIGINS.entity,
  FORM_ORIGINS.contact,
  FORM_ORIGINS.case,
];

const PRESET_PARAMS = [
  ["origin", "origin"],
  ["entity_id", "entityId"],
  ["contact_id", "contactId"],
  ["campaign_id", "campaignId"],
  ["case_id", "caseId"],
];

const buildCreatePath = (preset = {}) => {
  const params = new URLSearchParams();
  PRESET_PARAMS.forEach(([param, key]) => {
    if (preset[key] != null && preset[key] !== "") {
      params.set(param, preset[key]);
    }
  });
  const query = params.toString();
  return query ? `${LIST_PATH}/new?${query}` : `${LIST_PATH}/new`;
};

export const revenueOpportunityPaths = {
  list: LIST_PATH,
  detail: id => `${LIST_PATH}/${id}`,
  edit: id => `${LIST_PATH}/${id}/edit`,
  create: buildCreatePath,
  clone: id => `${LIST_PATH}/new?clone=${id}`,
};

const toId = value => (value ? Number(value) : null);

/** Reads the create preset back from the search params of the create URL. */
export const readCreatePreset = searchParams => ({
  origin: searchParams.get("origin"),
  entityId: toId(searchParams.get("entity_id")),
  contactId: toId(searchParams.get("contact_id")),
  campaignId: toId(searchParams.get("campaign_id")),
  caseId: toId(searchParams.get("case_id")),
});
